













































import Vue from 'vue';
import Component from 'vue-class-component';
import { Action } from 'vuex-class';
import { Prop } from 'vue-property-decorator';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * Types
 */
import { PayloadChangePasswordRequest } from '@/api/authentication';

const initialForm = {
	currentPassword: '',
	newPassword: '',
	newPasswordConfirm: ''
};

/**
 * Composant de fenêtre modale de changement de mot de passe.
 */
@Component({ mixins: [mixinsAPI] })
export default class ChangePasswordDialog extends Vue {
	$refs!: {
		modal: Dialog
	};

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Propriétés */
	@Prop()
	onSubmit!: (form: PayloadChangePasswordRequest) => Promise<any>;

	/** Attributs */
	form = new PayloadChangePasswordRequest();
	isLoading = false;

	/** Méthodes */
	async open() {
		this.form = Object.assign({}, initialForm);
		this.$refs.modal.open();
	}

	close() {
		this.$refs.modal.close();
	}

	async handleSubmit() {
		this.isLoading = true;
		try {
			await this.onSubmit(this.form);

			this.openInfo(this.$t('snackbar.success'));
			this.isLoading = false;
			this.close();
		}
		catch (err) {
			(this as any).handleAPIError(err);
			this.isLoading = false;
		}
	}
}
